// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./SelectButton";
export type { SelectButtonProps } from "./SelectButton";
